<template>
  <div
    class="withdrawal-widget__confirm"
    data-test-id="withdrawal-confirm"
  >
    <div
      class="withdrawal-widget__confirm-row"
      data-test-id="withdrawal-confirm-row"
    >
      <p data-test-id="withdrawal-confirm-asset-title">
        {{ i18n.lbl_asset() }}
      </p>
      <p data-test-id="withdrawal-confirm-asset">
        {{ selectedAsset }}
      </p>
    </div>
    <div
      class="withdrawal-widget__confirm-row"
      data-test-id="withdrawal-confirm-row"
    >
      <p data-test-id="withdrawal-confirm-amount-title">
        {{ i18n.lbl_amount() }}
      </p>
      <p data-test-id="withdrawal-confirm-amount">
        {{ `${i18n.c(options.amount)} ${selectedAsset}` }}
      </p>
    </div>
    <div
      v-if="options.externalDetails.address"
      class="withdrawal-widget__confirm-row"
      data-test-id="withdrawal-confirm-row"
    >
      <p data-test-id="withdrawal-confirm-address-title">
        {{ i18n.withdraw_external({ asset: '' }) }}
      </p>
      <p data-test-id="withdrawal-confirm-address">
        {{ `${options.externalDetails.address}` }}
      </p>
    </div>
    <div class="withdrawal-widget__confirm-fees">
      <b
        class="withdrawal-widget__confirm-title"
        data-test-id="withdrawal-confirm-fees-title"
      >
        {{ i18n.lbl_sender_fees() }}
      </b>
      <div
        class="withdrawal-widget__confirm-row"
        data-test-id="withdrawal-confirm-row"
      >
        <p data-test-id="withdrawal-confirm-fixed-title">
          {{ i18n.lbl_fixed() }}
        </p>
        <p data-test-id="withdrawal-confirm-fixed">
          {{ `${i18n.c(options.fee.fixed)} ${selectedAsset}` }}
        </p>
      </div>

      <div
        class="withdrawal-widget__confirm-row"
        data-test-id="withdrawal-confirm-row"
      >
        <p data-test-id="withdrawal-confirm-percent-title">
          {{ i18n.lbl_percent() }}
        </p>
        <p data-test-id="withdrawal-confirm-percent">
          {{ `${i18n.c(options.fee.percent)} ${selectedAsset}` }}
        </p>
      </div>
    </div>
    <div
      class="withdrawal-widget__confirm-btns"
    >
      <md-button
        class="btn md-primary"
        data-test-id="withdrawal-confirm-cancel-btn"
        @click="$emit(commonEvents.cancelClickEvent)"
      >
        {{ i18n.lbl_cancel() }}
      </md-button>
      <md-button
        class="btn md-mint"
        data-test-id="withdrawal-confirm-confirm-btn"
        :disabled="isPending"
        @click="$emit(commonEvents.confirmClickEvent)"
      >
        <span v-if="!isPending">
          {{ i18n.lbl_confirm() }}
        </span>
        <md-progress-spinner
          v-else
          :md-diameter="24"
          :md-stroke="3"
          md-mode="indeterminate"
        />
      </md-button>
    </div>
  </div>
</template>

<script>
  import { i18n } from '@js/i18n'
  import { commonEvents } from '@js/events/common_events'

  export default {
    name: 'ConfirmStep',
    props: {
      options: { type: Object, default: () => ({}) },
      selectedAsset: { type: String, default: '' },
      isPending: { type: Boolean, default: false }
    },
    data: _ => ({
      i18n,
      commonEvents
    })
  }
</script>

<style lang="scss" scoped>
@import '~scss/variables';

.withdrawal-widget__confirm {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 20px;
  height: calc(100% - 22.5px);

  &-row {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 16px;
    margin-bottom: 3px;
    padding-bottom: 2px;
    border-bottom: 1px solid $grey;
  }

  &-title {
    font-size: 16px;
    margin-top: 20px;
    display: block;
  }

  &-fees {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &-btns {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: auto;

    /deep/ .md-progress-spinner.md-theme-default .md-progress-spinner-circle {
      stroke: $color-graphite;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/app/dashboard/widgets/WithdrawalWidget/ConfirmStep.vue